import { makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { CollapsibleSection } from '../../common/collapsible-section';
import { SegmentAttributeOperator, SegmentCompositionSelection } from '../../../models/segments';
import * as styles from '../view-segment.module.scss';
import clsx from 'clsx';

const useStyles = makeStyles({
  headerMargin: {
    margin: 20,
    marginTop: 5
  },
  inputGrouping: {
    flexDirection: 'column'
  },
  segmentInfoRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10
  },
  segmentName: {
    fontWeight: 600
  }
});

interface ViewCompositionSelectionProps {
  composition: SegmentCompositionSelection;
}

const ViewCompositionSelection = ({ composition }: ViewCompositionSelectionProps) => {
  const classes = useStyles();
  const [selectionCollapsed, setSelectionCollapsed] = useState<boolean>(false);

  return (
    <CollapsibleSection
      title="Optional: Segment Selection"
      collapsed={selectionCollapsed}
      onCollapse={setSelectionCollapsed}
      className={classes.headerMargin}
    >
      <div className={clsx(styles.attributeRow, classes.inputGrouping)}>
        <div className={classes.segmentInfoRow}>
          <div>
            Selected Segment: <span className={classes.segmentName}>{composition.segmentName}</span>
          </div>
          <div className={styles.customers}>Total Customer: {composition.customers?.toLocaleString()}</div>
        </div>
        <div>
          Interaction: <span className={styles.operator}>{SegmentAttributeOperator[composition.segmentOperator]}</span>
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default ViewCompositionSelection;
